"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.container = exports.saDependencies = void 0;
var event_tracking_core_1 = require("@al/event-tracking-core");
Object.defineProperty(exports, "container", { enumerable: true, get: function () { return event_tracking_core_1.container; } });
var inversify_1 = require("inversify");
var reporter_1 = require("./reporter");
var ClickEventObserver_1 = require("./services/ClickEventObserver");
var PageConfigService_1 = require("./services/PageConfigService");
var SDKConfigService_1 = require("./services/SDKConfigService");
var SensorAnalyticsService_1 = require("./services/SensorAnalyticsService");
var ClickService_1 = require("./services/ClickService");
var types_1 = require("./types");
var TimeProcessorTask_1 = require("./services/TimeProcessorTask");
var BeforeSendTask_1 = require("./services/BeforeSendTask");
var SendToSaService_1 = require("./services/SendToSaService");
var SendToSaTask_1 = require("./services/SendToSaTask");
var LeaveOpsService_1 = require("./services/LeaveOpsService");
var VisibilityEventObserver_1 = require("./services/VisibilityEventObserver");
var InputEventObserver_1 = require("./services/InputEventObserver");
var InputService_1 = require("./services/InputService");
var PasteEventObserver_1 = require("./services/PasteEventObserver");
var ExposeEventObserver_1 = require("./services/ExposeEventObserver");
var CleanDataTask_1 = require("./services/CleanDataTask");
exports.saDependencies = new inversify_1.ContainerModule(function (bind) {
    bind(types_1.TYPES.ISaReportService).to(reporter_1.Reporter).inRequestScope();
});
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IEventOrderBucket)
    .to(event_tracking_core_1.EventOrderBucket)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.EventOrderBucket);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IConfigService)
    .to(SDKConfigService_1.SDKConfigService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.SDKConfigService);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IConfigService)
    .to(PageConfigService_1.PageConfigService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.PageConfigService);
event_tracking_core_1.container
    .bind(types_1.TYPES.ISensorAnalyticsService)
    .to(SensorAnalyticsService_1.SensorAnalyticsService)
    .inSingletonScope();
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(ClickEventObserver_1.ClickEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.ClickEventObserver);
event_tracking_core_1.container.bind(types_1.TYPES.IClickService).to(ClickService_1.ClickService).inSingletonScope();
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(BeforeSendTask_1.BeforeSendTask)
    .whenTargetNamed(types_1.TAG.BeforeSendTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(TimeProcessorTask_1.TimeProcessorTask)
    .whenTargetNamed(types_1.TAG.TimeProcessorTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(CleanDataTask_1.CleanDataTask)
    .whenTargetNamed(types_1.TAG.CleanDataTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(SendToSaTask_1.SendToSaTask)
    .whenTargetNamed(types_1.TAG.SendToSaTask);
event_tracking_core_1.container.bind(types_1.TYPES.ISendToSaService).to(SendToSaService_1.SendToSaService).inSingletonScope();
event_tracking_core_1.container.bind(types_1.TYPES.ILeaveOpsService).to(LeaveOpsService_1.LeaveOpsService);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(VisibilityEventObserver_1.VisibilityEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.VisibilityEventObserver);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IStoreService)
    .to(event_tracking_core_1.LocalStoreService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.LocalStoreService);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IStoreService)
    .to(event_tracking_core_1.SessionStoreService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.SessionStoreService);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(InputEventObserver_1.InputEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.InputEventObserver);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(PasteEventObserver_1.PasteEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.PasteEventObserver);
event_tracking_core_1.container.bind(types_1.TYPES.IInputService).to(InputService_1.InputService).inSingletonScope();
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(ExposeEventObserver_1.ExposeEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.ExposeEventObserver);
